import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { url } from '../../config';
import axios from 'axios';

import objectFitImages from 'object-fit-images';

export default class RelatedImg extends Component {
    constructor(props) {
        super(props);
        this.state = {
            img: '',
            type: 'actueel',
        };
    }

    componentDidMount() {
        objectFitImages();
        if (this.props.article) {
            this.getImg(this.props.article.ID);
        }
    }

    getImg(id) {
        // console.log(this.props.images);
        // getPostImage(2048);

        // const url = 'https://friendsagency.com';
        axios.get(`${url}/wp-json/wp/v2/posts/${id}`).then((response) => {
            const payload = response.data;
            if (payload.better_featured_image) {
                this.setState({
                    img:
                        payload.better_featured_image.media_details.sizes
                            .img_overview_half.source_url,
                    type: payload.acf.type,
                });
            }
        });
    }

    render() {
        return (
            <div className={this.state.img ? 'image-bg' : ''}>
                {this.state.img ? (
                    <img
                        src={this.state.img}
                        alt="Friends for Brands Related"
                    />
                ) : (
                    ''
                )}
                <div className="related-inner">
                    <header>
                        <h3 className="text__color--white">
                            {this.props.article.post_title}
                        </h3>
                    </header>
                    <Link
                        className="cta-btn"
                        to={`/${this.state.type}/${this.props.article.post_name}`}>
                        Read more
                    </Link>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/RelatedImg.jsx